var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp1X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-icon/help@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-icon/help",
    fill: "#3365FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.578625,0 0,3.57803125 0,8 L0,15.375 C0,15.7201875 0.2798125,16 0.625,16 L8,16 C12.4213438,16 16,12.4219687 16,8 C16,3.578625 12.4219687,0 8,0 Z M8,1.25 C11.7305313,1.25 14.75,4.26896875 14.75,8 C14.75,11.7305313 11.7310312,14.75 8,14.75 L1.25,14.75 L1.25,8 C1.25,4.26946875 4.26896875,1.25 8,1.25 Z M7.7549375,10.725625 C7.29746875,10.725625 6.92709375,11.106875 6.92709375,11.564375 C6.92709375,12.0109688 7.2865625,12.403125 7.7549375,12.403125 C8.2233125,12.403125 8.5936875,12.011 8.5936875,11.564375 C8.5936875,11.106875 8.21246875,10.725625 7.7549375,10.725625 Z M7.8965625,4.3750625 C6.42603125,4.3750625 5.7506875,5.24646875 5.7506875,5.8346875 C5.7506875,6.25953125 6.110125,6.45559375 6.40425,6.45559375 C6.9924375,6.45559375 6.7528125,5.61684375 7.863875,5.61684375 C8.40853125,5.61684375 8.84425,5.8565 8.84425,6.3575625 C8.84425,6.9458125 8.23425,7.28346875 7.87478125,7.58846875 C7.55890625,7.86078125 7.14496875,8.30740625 7.14496875,9.2441875 C7.14496875,9.81059375 7.2974375,9.974 7.7440625,9.974 C8.2778125,9.974 8.38671875,9.734375 8.38671875,9.52740625 C8.38671875,8.96096875 8.39765625,8.6341875 8.99675,8.1658125 C9.29084375,7.9370625 10.21675,7.19634375 10.21675,6.17240625 C10.21675,5.14846875 9.29084375,4.3750625 7.8965625,4.3750625 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp1X);
export default __webpack_public_path__ + "static/media/help1x.3127092d0e8765ddf1bc1b5b92363de1.svg";
export { ForwardRef as ReactComponent };